import {
	CHECK_AVAILABILITIES_REQUEST,
	CLEAR_BOOKING,
	CLEAR_PROMOTION_VALUE,
	SEND_PROMOTION_CODE_SUCCESS,
	RESTORE_BOOKING_SESSION_REQUEST,
	RESTORE_BOOKING_SESSION_SUCCESS,
	CLEAR_PROMOTION_VALUE_SUCCESS,
} from "app/actionTypes";

const defaultState = {
	status: undefined,
	promotionValue: 0,
	promotionCode: undefined,
	message: "",
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case RESTORE_BOOKING_SESSION_REQUEST:
		case CHECK_AVAILABILITIES_REQUEST:
		case CLEAR_BOOKING: {
			return defaultState;
		}
		case SEND_PROMOTION_CODE_SUCCESS:
			return {
				...state,
				...{
					status: action.res.data.status,
					message: action.res.data.message,
					promotionValue: action.res.data.value,
					promotionCode:
						action.res.data.value > 0
							? JSON.parse(action.res.config.data).promoCode
							: undefined,
				},
			};
		case RESTORE_BOOKING_SESSION_SUCCESS: {
			const { promoCodeResponse = {}, promoCodeRequest = {} } = action.res.data;

			return {
				status: promoCodeResponse?.status,
				promotionValue: promoCodeResponse?.value,
				promotionCode:
					promoCodeResponse?.value > 0 ? promoCodeRequest.promoCode : undefined,
			};
		}
		case CLEAR_PROMOTION_VALUE:
		case CLEAR_PROMOTION_VALUE_SUCCESS:
			return defaultState;

		default:
			return state;
	}
};
